import React, { createContext, useContext } from "react";

type SSRStatusRef = { statusCode: number; redirectUrl?: string };

type SSRStatusContextType = {
    setStatusCode: (code: number) => void;
    setRedirect: (url: string) => void;
};

const SSRStatusContext = createContext<SSRStatusContextType>({
    setStatusCode: () => {},
    setRedirect: () => {},
});

export const useSSRStatus = () => useContext(SSRStatusContext);

export const SSRStatusProvider: React.FC<{
    statusRef: SSRStatusRef,
    children: React.ReactNode,
}> = ({ statusRef, children }) => {
    const value = {
        setStatusCode: (code: number) => { statusRef.statusCode = code; },
        setRedirect: (url: string) => {
            statusRef.statusCode = 301;
            statusRef.redirectUrl = url;
        },
    };

    return (
        <SSRStatusContext.Provider value={value}>
            {children}
        </SSRStatusContext.Provider>
    );
};

export default SSRStatusContext;
